<div class="dialog-header">
  <ng-content></ng-content>
  @if (!hideCloseButton()) {
    <mat-icon class="close-icon" [svgIcon]="'close'" (click)="closeClick.emit()"></mat-icon>
  }
</div>
